export const translations = {
  cs: {
    nav: {
      features: "Co dostanete",
      pricing: "Ceník",
      faq: "Časté dotazy",
      login: "Přihlásit se",
      cta: "Nezávazně poptat",
    },
    hero: {
      eyebrow: "Web pro ubytování & pohostinství",
      title_1: "Web na míru",
      title_2: "za 3 pracovní",
      title_3: "dny.",
      subtitle:
        "Staysy vytvoří pro vaše ubytování profesionální web přesně na míru — od designu přes rezervace až po spuštění. Vy se staráte o hosty, my o web.",
      cta_primary: "Nezávazně poptat",
      cta_secondary: "Prohlédnout ukázku",
      micro: "Ozveme se do 24 hodin · Web spustíme za 3 pracovní dny",
      stat_1: "50+",
      stat_1_label: "webů v provozu",
      stat_2: "4.9/5",
      stat_2_label: "průměrné hodnocení",
      stat_3: "3 dny",
      stat_3_label: "od poptávky k webu",
    },
    logos: "Důvěřují nám penziony, butikové hotely a apartmány po celé republice",
    features: {
      eyebrow: "Co dostanete",
      title: "Vše, co vaše ubytování potřebuje.",
      subtitle:
        "Každý web stavíme od základu pro konkrétní ubytování. Žádné šablony z krabice — jen váš příběh, vaše fotky a rezervace, které přicházejí.",
      list: [
        {
          title: "Rezervační systém",
          desc: "Přímé rezervace bez provize. Propojení s Bookingem, Airbnb i Google kalendářem.",
        },
        {
          title: "Galerie a fotky",
          desc: "Plnoobrazové galerie s lazy-loadem a foto alba pro každý pokoj nebo apartmán.",
        },
        {
          title: "Vícejazyčnost",
          desc: "Čeština a angličtina standardně. Němčina, polština nebo další jazyk na přání.",
        },
        {
          title: "SEO a Google",
          desc: "Optimalizovaná struktura, mapy, schémata a rychlost. Vaše ubytování hosté najdou první.",
        },
        {
          title: "Vlastní doména",
          desc: "Připojíme vaši stávající doménu nebo pomůžeme vybrat novou. SSL a hosting v ceně.",
        },
        {
          title: "Mobil & rychlost",
          desc: "Lighthouse 95+ skóre. Web se načte bleskově na každém telefonu i tabletu.",
        },
      ],
    },
    showcase: {
      eyebrow: "Příklad ze života",
      title: "Vyrobeno pro pohostinné lidi.",
      subtitle:
        "Vaši hosté pocítí domov ještě než dorazí. Každý web předává příběh vašeho místa — hřejivě, pravdivě a bez kompromisů na výkonu.",
      bullet_1: "Design přesně na míru vašemu ubytování",
      bullet_2: "Recenze hostů s hvězdičkami",
      bullet_3: "Mapa s atrakcemi v okolí",
      bullet_4: "Napojení na Booking, Airbnb, Smoobu",
    },
    pricing: {
      eyebrow: "Ceník",
      title: "Transparentní ceny, žádná překvapení.",
      subtitle:
        "Jednorázový setup zahrnuje design, vývoj i spuštění. Měsíční správa pak pokrývá hosting, SSL, aktualizace a podporu.",
      setup_label: "Jednorázový setup",
      monthly_label: "+ měsíční správa",
      most_popular: "Nejoblíbenější",
      cta: "Poptat balíček",
      cta_premium: "Domluvit hovor",
      currency: "Kč",
      period: "/ měsíc",
      tiers: [
        {
          id: "basic",
          name: "Základ",
          tagline: "Pro malé apartmány a chalupy",
          setupPrice: 7000,
          monthlyFee: 290,
          features: [
            "Web s až 5 pokoji / apartmány",
            "Čeština + angličtina",
            "Poptávkový formulář",
            "Připojení vlastní domény",
            "SSL & hosting",
            "E-mailová podpora",
          ],
        },
        {
          id: "pro",
          name: "Standard",
          tagline: "Pro penziony a malé hotely",
          setupPrice: 12000,
          monthlyFee: 590,
          features: [
            "Web s až 20 pokoji / apartmány",
            "Až 3 jazyky",
            "Online rezervace s platbou",
            "Propojení s Bookingem nebo Airbnb",
            "Galerie pokojů a okolí",
            "Mapa s atrakcemi",
            "Prioritní podpora 7 dní v týdnu",
          ],
        },
        {
          id: "premium",
          name: "Prémiový",
          tagline: "Pro větší objekty a resorty",
          setupPrice: 18000,
          monthlyFee: 1290,
          features: [
            "Neomezený počet pokojů a objektů",
            "Vlastní design a branding",
            "Smoobu / channel manager API",
            "Vícejazyčný web (libovolný počet jazyků)",
            "Osobní projektový manažer",
            "Onboarding a školení v ceně",
            "SLA 99,9 % uptime",
          ],
        },
      ],
    },
    faq: {
      eyebrow: "Časté dotazy",
      title: "Otázky, které kladou nejčastěji.",
      items: [
        {
          q: "Za jak dlouho bude web hotový?",
          a: "Do 3 pracovních dnů od schválení podkladů — textů, fotek a přístupu k doméně. U komplexnějších projektů (Prémiový balíček) může být lhůta delší, vždy se domluvíme předem.",
        },
        {
          q: "Co všechno je v ceně setupu?",
          a: "Design na míru, vývoj, připojení domény, SSL certifikát, nastavení rezervačního systému a spuštění webu. Vše klíč na klíč — nic neřešíte.",
        },
        {
          q: "Potřebuji něco připravit předem?",
          a: "Stačí fotky ubytování, základní texty (nebo nám řeknete o objektu a texty napíšeme za vás) a přístup k doméně. Zbytek je na nás.",
        },
        {
          q: "Co zahrnuje měsíční správa?",
          a: "Hosting, SSL, pravidelné aktualizace, technická podpora a drobné úpravy obsahu. Nemusíte myslet na nic technického.",
        },
        {
          q: "Bere si Staysy procenta z rezervací?",
          a: "Ne. Žádné provize, žádné srážky. Platíte pevný měsíční poplatek a 100 % z každé rezervace zůstává vám.",
        },
        {
          q: "Mohu web kdykoli zrušit nebo převést?",
          a: "Závazek je měsíční, výpovědní lhůta jeden měsíc. Při ukončení spolupráce vám předáme všechna data, texty i fotky.",
        },
      ],
    },
    cta: {
      title: "Váš web za 3 pracovní dny.",
      subtitle:
        "Napište nám svůj e-mail a my se ozveme do 24 hodin. Probereme vaše ubytování a připravíme nezávaznou nabídku.",
      input_placeholder: "vase@ubytovani.cz",
      button: "Poptat web",
      micro: "Ozveme se do 24 hodin. Bez závazků.",
    },
    footer: {
      tagline: "Weby na míru pro ubytování a pohostinství. Vyrobeno se zelenou.",
      product: "Produkt",
      company: "Společnost",
      legal: "Právní",
      links: {
        features: "Co dostanete",
        pricing: "Ceník",
        templates: "Ukázky",
        roadmap: "Roadmap",
        about: "O nás",
        blog: "Blog",
        careers: "Kariéra",
        contact: "Kontakt",
        terms: "Obchodní podmínky",
        privacy: "Ochrana osobních údajů",
        cookies: "Cookies",
      },
      copyright: "© 2025 Staysy s.r.o. Všechna práva vyhrazena.",
    },
  },
  en: {
    nav: {
      features: "What you get",
      pricing: "Pricing",
      faq: "FAQ",
      login: "Log in",
      cta: "Get a quote",
    },
    hero: {
      eyebrow: "Hospitality websites, made to order",
      title_1: "A bespoke website",
      title_2: "in 3 working",
      title_3: "days.",
      subtitle:
        "Staysy builds a professional, tailor-made website for your accommodation — from design and bookings to going live. You focus on your guests, we handle the web.",
      cta_primary: "Get a free quote",
      cta_secondary: "View showcase",
      micro: "We reply within 24 hours · Live in 3 working days",
      stat_1: "50+",
      stat_1_label: "sites live",
      stat_2: "4.9/5",
      stat_2_label: "average rating",
      stat_3: "3 days",
      stat_3_label: "from enquiry to live",
    },
    logos: "Trusted by guesthouses, boutique hotels and apartments across the country",
    features: {
      eyebrow: "What you get",
      title: "Everything your accommodation needs.",
      subtitle:
        "Every site is built from scratch for a specific property. No off-the-shelf templates — just your story, your photos and bookings that come in.",
      list: [
        {
          title: "Booking system",
          desc: "Direct, commission-free bookings. Connected to Booking.com, Airbnb and Google Calendar.",
        },
        {
          title: "Photo galleries",
          desc: "Full-screen lazy-loaded galleries and photo albums for every room or apartment.",
        },
        {
          title: "Multilingual",
          desc: "Czech and English as standard. German, Polish or any other language on request.",
        },
        {
          title: "SEO & Google",
          desc: "Optimised structure, maps, schema and speed. Your property shows up first.",
        },
        {
          title: "Custom domain",
          desc: "We connect your existing domain or help you pick a new one. SSL and hosting included.",
        },
        {
          title: "Mobile & speed",
          desc: "Lighthouse 95+ scores. Loads instantly on every phone and tablet.",
        },
      ],
    },
    showcase: {
      eyebrow: "Made with care",
      title: "Built for hospitable people.",
      subtitle:
        "Your guests will feel at home before they arrive. Each site carries the story of your place — warmly, truthfully, with no performance compromise.",
      bullet_1: "Design tailored to your property",
      bullet_2: "Star-rated guest reviews",
      bullet_3: "Map with nearby attractions",
      bullet_4: "Booking.com, Airbnb, Smoobu integration",
    },
    pricing: {
      eyebrow: "Pricing",
      title: "Transparent prices, no surprises.",
      subtitle:
        "The one-time setup covers design, development and launch. Monthly care then covers hosting, SSL, updates and support.",
      setup_label: "One-time setup",
      monthly_label: "+ monthly care",
      most_popular: "Most popular",
      cta: "Request this plan",
      cta_premium: "Book a call",
      currency: "CZK",
      period: "/ month",
      tiers: [
        {
          id: "basic",
          name: "Basic",
          tagline: "For small apartments & cottages",
          setupPrice: 7000,
          monthlyFee: 290,
          features: [
            "Website with up to 5 rooms / apartments",
            "Czech + English",
            "Enquiry form",
            "Custom domain connection",
            "SSL & hosting",
            "Email support",
          ],
        },
        {
          id: "pro",
          name: "Standard",
          tagline: "For B&Bs and small hotels",
          setupPrice: 12000,
          monthlyFee: 590,
          features: [
            "Website with up to 20 rooms / apartments",
            "Up to 3 languages",
            "Online booking with payment",
            "Booking.com or Airbnb integration",
            "Room & area galleries",
            "Nearby attractions map",
            "Priority 7-day support",
          ],
        },
        {
          id: "premium",
          name: "Premium",
          tagline: "For larger properties & resorts",
          setupPrice: 18000,
          monthlyFee: 1290,
          features: [
            "Unlimited rooms & properties",
            "Custom design & branding",
            "Smoobu / channel manager API",
            "Multilingual (any number of languages)",
            "Personal project manager",
            "Onboarding & training included",
            "99.9% uptime SLA",
          ],
        },
      ],
    },
    faq: {
      eyebrow: "FAQ",
      title: "Questions we hear most often.",
      items: [
        {
          q: "How quickly will my website be ready?",
          a: "Within 3 working days of approving the materials — texts, photos and domain access. For more complex projects (Premium plan) the timeline may be longer; we always agree upfront.",
        },
        {
          q: "What's included in the setup fee?",
          a: "Custom design, development, domain connection, SSL certificate, booking system setup and launch. Everything turnkey — you don't have to deal with any of it.",
        },
        {
          q: "What do I need to prepare in advance?",
          a: "Photos of your property, basic texts (or just tell us about your place and we'll write them for you) and access to your domain. Everything else is on us.",
        },
        {
          q: "What does the monthly fee cover?",
          a: "Hosting, SSL, regular updates, technical support and minor content changes. No technical worries on your end.",
        },
        {
          q: "Does Staysy take a cut from bookings?",
          a: "No. Zero commission. You pay a flat monthly fee and keep 100% of every booking.",
        },
        {
          q: "Can I cancel or transfer the site?",
          a: "The commitment is monthly with one month's notice. When you leave, we hand over all your data, texts and photos.",
        },
      ],
    },
    cta: {
      title: "Your website in 3 working days.",
      subtitle:
        "Leave us your email and we'll get back to you within 24 hours. We'll talk about your property and put together a no-obligation quote.",
      input_placeholder: "you@yourstay.com",
      button: "Request a quote",
      micro: "We reply within 24 hours. No commitment.",
    },
    footer: {
      tagline: "Bespoke hospitality websites. Built green.",
      product: "Product",
      company: "Company",
      legal: "Legal",
      links: {
        features: "What you get",
        pricing: "Pricing",
        templates: "Showcase",
        roadmap: "Roadmap",
        about: "About",
        blog: "Blog",
        careers: "Careers",
        contact: "Contact",
        terms: "Terms",
        privacy: "Privacy",
        cookies: "Cookies",
      },
      copyright: "© 2025 Staysy s.r.o. All rights reserved.",
    },
  },
};
